import { Component, OnInit, ViewChild } from '@angular/core';
import { ProductInventoryService } from 'src/app/shared/services/product-inventory.service';
import { ProductInventory } from 'src/app/shared/services/products.service';
import { UIChart } from 'primeng/chart';
import { FilterService } from 'primeng/api';
import { GroupedOrder } from 'src/app/domain/grouped-order';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { saveAs } from 'file-saver';


import autoTable, { Table } from 'jspdf-autotable';
@Component({
  selector: 'app-product-inventory',
  templateUrl: './product-inventory.component.html',
  styleUrls: ['./product-inventory.component.scss'],
})
export class ProductInventoryComponent implements OnInit {
  @ViewChild('barChart') barChart: UIChart;
  @ViewChild('dt6') table: Table;
  @ViewChild('orderStatsPieChart') orderStatsPieChart: UIChart;
  @ViewChild('orderStatsChart') orderStatsChart: UIChart;

  products: ProductInventory[] = [];
  filteredProducts: ProductInventory[] = [];
  barChartData: any;
  barChartOptions: any;

  customerOrderCounts: any[] = [];
  groupedView: boolean = true;
  groupedOrder: GroupedOrder[] = [];
  orderStatsChartData: any;
  orderStatsChartOptions: any;
  selectedOrderStatsDataType: string = 'ordersCount';
  selectedOrderStatsGroupBy: string = 'customer';

  filteredGroupedOrder: GroupedOrder[] = [];

  orderStatsDataTypes: any[] = [
    { label: 'Total Items', value: 'ordersCount' },
    { label: 'Ordered Pieces', value: 'orderedPieces' },
    { label: 'Ordered Price', value: 'orderedPrice' }
  ];
  selectedOrderPiecesDataType: string = 'orderedPieces';
  orderPiecesDataTypes: any[] = [
    { label: 'Ordered Pieces', value: 'orderedPieces' },
    { label: 'Stock Count', value: 'stockCount' },
    { label: 'Reserved Stock', value: 'reservedStock' },
    { label: 'On-hand Stock', value: 'onHandStock' },
    { label: 'Available Pieces', value: 'availablePieces' },
    { label: 'Order Count', value: 'orderCount' },
    { label: 'Stocked Pieces', value: 'stockPiecesCount' },
    { label: 'Total Pieces', value: 'totalPieces' }
  ];
  orderStatsGroupByOptions: any[] = [
    { label: 'Customer', value: 'customer' },
    { label: 'Product', value: 'product' }
  ];
  orderStatsPieChartData: any;
  orderStatsPieChartOptions: any;
  constructor(private productInventoryService: ProductInventoryService, private filterService: FilterService) {}

  ngOnInit() {
    this.loadProductInventory();
    this.initializeBarChart();
    this.loadCustomerGroups();
    this.initializeOrderStatsChart();
    this.updateOrdersStatisticsChart();
    this.initializeOrderStatsPieChart();
    this.updateOrderStatsPieChartData();

  }

  loadProductInventory() {
    this.productInventoryService.getProductInventory()
      .toPromise()
      .then(response => {
        this.products = response;
        this.filteredProducts = response;
        this.updateBarChartData();
      })
      .catch(error => {
        console.error('Error loading product inventory:', error);
      });
  }

  loadCustomerGroups() {
    this.productInventoryService.getCustomerGroups()
      .toPromise()
      .then(response => {
        this.groupedOrder = response || []; 
        this.filteredGroupedOrder = [...this.groupedOrder]; 
        this.updateOrderStatsChartData();
        this.updateOrderStatsPieChartData();
      })
      .catch(error => {
        console.error('Error loading customer groups:', error);
        this.groupedOrder = [];
        this.filteredGroupedOrder = [];
      });
  }

  initializeBarChart() {
    this.barChartOptions = {
      responsive: true,
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true
        }
      },
      plugins: {
        tooltip: {
          callbacks: {
            title: (tooltipItems) => {
              return tooltipItems[0].label;
            },
            label: (tooltipItem) => {
              const datasetLabel = tooltipItem.dataset.label;
              const value = tooltipItem.raw;
              return `${datasetLabel}: ${value}`;
            }
          }
        },
        legend: {
          position: 'top',
        }
      }
    };
  }

  initializeOrderStatsPieChart() {
    this.orderStatsPieChartOptions = {
      responsive: true,
      plugins: {
        legend: {
          position: 'right',
        },
        tooltip: {
          callbacks: {
            label: (tooltipItem) => {
              const datasetLabel = tooltipItem.dataset.label || '';
              const value = tooltipItem.raw;
              return `${datasetLabel}: ${value}`;
            }
          }
        }
      }
    };
  }

  updateOrderStatsPieChartData() {

    const groupedData = this.filteredGroupedOrder.reduce((acc, order) => {
      if (!acc[order.customerName]) {
        acc[order.customerName] = 0;
      }
      acc[order.customerName] += order.orderedPrice;
      return acc;
    }, {});


    const labels = Object.keys(groupedData);
    const data = Object.values(groupedData);


    const predefinedColors = [
      '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
      '#FF9F40', '#E7E9ED', '#F7464A', '#46BFBD', '#FDB45C'
    ];


    const backgroundColors = labels.map((_, index) => {
      if (index < predefinedColors.length) {
        return predefinedColors[index];
      }
      return this.getRandomChartColor();
    });

    this.orderStatsPieChartData = {
      labels: labels,
      datasets: [
        {
          data: data,
          backgroundColor: backgroundColors,
          hoverBackgroundColor: backgroundColors
        }
      ]
    };

    if (this.orderStatsPieChart) {
      this.orderStatsPieChart.reinit();
    }
  }



  toggleGroupedView() {
    this.groupedView = !this.groupedView;
  }

  onTableFilter(event: any) {
    this.filteredProducts = event.filteredValue || [];
    this.updateBarChartData();
  }



  
  exportPdfForInventoy() {
    const doc = new jsPDF('landscape', 'pt', 'a4');

    const columns = [
      { header: '#', dataKey: 'index' },
      { header: 'Category', dataKey: 'productCategory' },
      { header: 'Type', dataKey: 'productType' },
      { header: 'Item', dataKey: 'productItem' },
      { header: 'Stocks Count', dataKey: 'stockCount' },
      { header: 'Reserved Stocks', dataKey: 'reservedStock' },
      { header: 'On-hand Stocks', dataKey: 'onHandStock' },
      { header: 'Order Count', dataKey: 'orderCount' },
      { header: 'Stocked Pieces', dataKey: 'stockPiecesCount' },
      { header: 'Ordered Pieces', dataKey: 'orderedPieces' },
      { header: 'Total Pieces', dataKey: 'totalPieces' },
      { header: 'Available Pieces', dataKey: 'availablePieces' }
    ];

    // Use filteredProducts instead of products
    const data = this.filteredProducts;

    const rows = data.map((row: any, index: number) => ({
      index: index + 1,
      productCategory: row.productCategory,
      productType: row.productType,
      productItem: row.productItem,
      stockCount: row.stockCount,
      reservedStock: row.reservedStock,
      onHandStock: row.onHandStock,
      orderCount: row.orderCount,
      stockPiecesCount: row.stockPiecesCount,
      orderedPieces: row.orderedPieces,
      totalPieces: row.totalPieces,
      availablePieces: row.availablePieces
    }));

    autoTable(doc, {
      columns: columns,
      body: rows,
      theme: 'grid',
      styles: {
        font: 'helvetica',
        fontSize: 10,
        cellPadding: 2,
        overflow: 'linebreak',
        cellWidth: 'wrap'
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontSize: 10,
        fontStyle: 'bold',
        halign: 'center'
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240]
      },
      columnStyles: {
        index: { cellWidth: 26, halign: 'center' },
        productCategory: { cellWidth: 67, halign: 'center' },
        productType: { cellWidth: 49, halign: 'center' },
        productItem: { cellWidth: 54, halign: 'center' },
        stockCount: { cellWidth: 44, halign: 'center' },
        reservedStock: { cellWidth: 48.9, halign: 'center' },
        onHandStock: { cellWidth: 64, halign: 'center' },
        orderCount: { cellWidth: 64.5, halign: 'center' },
        stockPiecesCount: { cellWidth: 59.5, halign: 'center' },
        orderedPieces: { cellWidth: 50, halign: 'center' },
        totalPieces: { cellWidth: 50, halign: 'center' },
        availablePieces: { cellWidth: 50, halign: 'center' }
      },
      margin: { top: 20 }
    });
  
    doc.save('ProductInventory.pdf');
  }
  exportExcelForInventoy() {
    import("xlsx").then(xlsx => {
      // Use filteredProducts instead of products
      const worksheet = xlsx.utils.json_to_sheet(this.filteredProducts.map(product => ({
        'Category': product.productCategory,
        'Type': product.productType,
        'Item': product.productItem,
        'Stocks Count': product.stockCount,
        'Reserved Stocks': product.reservedStock,
        'On-hand Stocks': product.onHandStock,
        'Order Count': product.orderCount,
        'Stocked Pieces': product.stockPiecesCount,
        'Ordered Pieces': product.orderedPieces,
        'Total Pieces': product.totalPieces,
        'Available Pieces': product.availablePieces
      })));

      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "ProductInventory");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
  exportOrderStatsPdf() {
    const doc = new jsPDF('landscape', 'pt', 'a4');

    const columns = [
      { header: '#', dataKey: 'index' },
      { header: 'Customer Name', dataKey: 'customerName' },
      { header: 'Category', dataKey: 'categoryName' },
      { header: 'Type', dataKey: 'typeName' },
      { header: 'Item', dataKey: 'itemName' },
      { header: 'Orders Count', dataKey: 'ordersCount' },
      { header: 'Ordered Pieces', dataKey: 'orderedPieces' },
      { header: 'Ordered Price', dataKey: 'orderedPrice' }
    ];

    // Use filteredGroupedOrder instead of groupedOrder
    const data = this.filteredGroupedOrder;

    const rows = data.map((row: any, index: number) => ({
      index: index + 1,
      customerName: row.customerName,
      categoryName: row.categoryName,
      typeName: row.typeName,
      itemName: row.itemName,
      ordersCount: row.ordersCount,
      orderedPieces: row.orderedPieces,
      orderedPrice: row.orderedPrice
    }));

    autoTable(doc, {
      columns: columns,
      body: rows,
      theme: 'grid',
      styles: {
        font: 'helvetica',
        fontSize: 10,
        cellPadding: 2,
        overflow: 'linebreak',
        cellWidth: 'wrap'
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontSize: 10,
        fontStyle: 'bold',
        halign: 'center'
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240]
      },
      columnStyles: {
        index: { cellWidth: 26, halign: 'center' },
        customerName: { cellWidth: 67, halign: 'center' },
        categoryName: { cellWidth: 49, halign: 'center' },
        typeName: { cellWidth: 54, halign: 'center' },
        itemName: { cellWidth: 44, halign: 'center' },
        ordersCount: { cellWidth: 48.9, halign: 'center' },
        orderedPieces: { cellWidth: 64, halign: 'center' },
        orderedPrice: { cellWidth: 64.5, halign: 'center' }
      },
      margin: { top: 20 }
    });

    doc.save('OrderStatistics.pdf');
  }

  exportOrderStatsExcel() {
    import("xlsx").then(xlsx => {
      // Use filteredGroupedOrder instead of groupedOrder
      const worksheet = xlsx.utils.json_to_sheet(this.filteredGroupedOrder.map(order => ({
        'Customer Name': order.customerName,
        'Category': order.categoryName,
        'Type': order.typeName,
        'Item': order.itemName,
        'Total Items': order.ordersCount,
        'Ordered Pieces': order.orderedPieces,
        'Ordered Price': order.orderedPrice
      })));

      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "OrderStatistics");
    });
  }

  initializeOrderStatsChart() {
    this.orderStatsChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
          beginAtZero: true
        }
      },
      plugins: {
        tooltip: {
          callbacks: {
            title: (tooltipItems) => {
              return tooltipItems[0].label;
            },
            label: (tooltipItem) => {
              const datasetLabel = tooltipItem.dataset.label;
              const value = tooltipItem.raw;
              return `${datasetLabel}: ${value}`;
            }
          }
        },
        legend: {
          position: 'right',
        }
      }
    };
  }




  onOrderStatsDataTypeChange() {
    this.updateOrderStatsChartData();
  }

  onOrderStatsTableFilter(event: any) {
    this.filteredGroupedOrder = event.filteredValue || [];
    this.updateOrdersStatisticsChart();
    this.updateOrderStatsPieChartData();
  }

  updateBarChartData() {
    const filteredProducts = this.filteredProducts.filter(product => product[this.selectedOrderPiecesDataType] !== 0);
  
    const labels = filteredProducts.map(product => `${product.productCategory} ${product.productType} ${product.productItem}`);
    
    // Create two datasets - one for customer stock and one for SBM stock
    const customerStockData = filteredProducts.map(product => 
      product.customerStock ? product[this.selectedOrderPiecesDataType] : 0
    );
    
    const sbmStockData = filteredProducts.map(product => 
      !product.customerStock ? product[this.selectedOrderPiecesDataType] : 0
    );
  
    this.barChartData = {
      labels: labels,
      datasets: [
        {
          label: 'Customer Stock',
          backgroundColor: '#36A2EB',
          borderColor: '#1E88E5',
          data: customerStockData
        },
        {
          label: 'SBM Stock',
          backgroundColor: '#FF6384',
          borderColor: '#E53935',
          data: sbmStockData
        }
      ]
    };
  
    if (this.barChart) {
      this.barChart.reinit();
    }
  }
  // updateBarChartData() {
  //   const filteredProducts = this.filteredProducts.filter(product => product[this.selectedOrderPiecesDataType] !== 0);
  
  //   // Group products by category, type, and item
  //   const groupedProducts = {};
  //   filteredProducts.forEach(product => {
  //     const key = `${product.productCategory} ${product.productType} ${product.productItem}`;
  //     if (!groupedProducts[key]) {
  //       groupedProducts[key] = {
  //         customerStock: 0,
  //         sbmStock: 0
  //       };
  //     }
  
  //     if (product.customerStock) {
  //       groupedProducts[key].customerStock += product[this.selectedOrderPiecesDataType];
  //     } else {
  //       groupedProducts[key].sbmStock += product[this.selectedOrderPiecesDataType];
  //     }
  //   });
  
  //   const labels = Object.keys(groupedProducts);
  //   const customerStockData = labels.map(label => groupedProducts[label].customerStock);
  //   const sbmStockData = labels.map(label => groupedProducts[label].sbmStock);
  
  //   const predefinedColors = [
  //     'rgba(255, 99, 132, 0.6)', // Red with opacity
  //     'rgba(54, 162, 235, 0.6)', // Blue with opacity
  //     'rgba(255, 206, 86, 0.6)', // Yellow with opacity
  //     'rgba(75, 192, 192, 0.6)', // Green with opacity
  //     'rgba(153, 102, 255, 0.6)', // Purple with opacity
  //     'rgba(255, 159, 64, 0.6)', // Orange with opacity
  //     'rgba(231, 233, 237, 0.6)', // Light Grey with opacity
  //     'rgba(247, 70, 74, 0.6)', // Dark Red with opacity
  //     'rgba(70, 191, 189, 0.6)', // Teal with opacity
  //     'rgba(253, 180, 92, 0.6)' // Light Orange with opacity
  //   ];
  
  //   this.barChartData = {
  //     labels: labels,
  //     datasets: [
  //       {
  //         label: 'Customer Stocks',
  //         backgroundColor: predefinedColors[0],
  //         borderColor: predefinedColors[0],
  //         data: customerStockData,
  //         stack: 'Stack 0'
  //       },
  //       {
  //         label: 'SBM Stocks',
  //         backgroundColor: predefinedColors[1],
  //         borderColor: predefinedColors[1],
  //         data: sbmStockData,
  //         stack: 'Stack 0'
  //       }
  //     ]
  //   };
  
  //   if (this.barChart) {
  //     this.barChart.reinit();
  //   }
  // }
  onOrderPiecesDataTypeChange() {
    this.updateBarChartData();
    if (this.barChart) {
      this.barChart.refresh();
    }
  }

  updateOrderStatsChartData() {
    if (!this.filteredGroupedOrder || this.filteredGroupedOrder.length === 0) {
      this.orderStatsChartData = { labels: [], datasets: [] };
      return;
    }
  
    let groupedData;
    if (this.selectedOrderStatsGroupBy === 'customer') {
      groupedData = this.groupDataByCustomer();
    } else {
      groupedData = this.groupDataByProduct();
    }
  
    const labels = Object.keys(groupedData);
    const datasets = this.purchaseDateasets(groupedData);
  
    this.orderStatsChartData = {
      labels: labels,
      datasets: datasets
    };
  
    if (this.orderStatsChart) {
      this.orderStatsChart.refresh();
    }
  }


  getRandomChartColor(): string {
    const chartColors = [
      '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
      '#FF9F40', '#E7E9ED', '#F7464A', '#46BFBD', '#FDB45C'
    ];
    return chartColors[Math.floor(Math.random() * chartColors.length)];
  }


  onOrderStatsGroupByChange() {
    this.updateOrderStatsChartData();
  }



  groupDataByCustomer() {
    if (!this.filteredGroupedOrder || this.filteredGroupedOrder.length === 0) {
      return {}; // Return an empty object if the array is null or empty
    }
  
    return this.filteredGroupedOrder.reduce((acc, item) => {
      if (!acc[item.customerName]) {
        acc[item.customerName] = {};
      }
      const productKey = `${item.categoryName} - ${item.typeName} - ${item.itemName}`;
      acc[item.customerName][productKey] = item[this.selectedOrderStatsDataType];
      return acc;
    }, {});
  }

  groupDataByProduct() {
    return this.filteredGroupedOrder.reduce((acc, item) => {
      const productKey = `${item.categoryName} - ${item.typeName} - ${item.itemName}`;
      if (!acc[productKey]) {
        acc[productKey] = {};
      }
      acc[productKey][item.customerName] = item[this.selectedOrderStatsDataType];
      return acc;
    }, {});
  }

  purchaseDateasetsold(groupedData) {
    const firstGroup = Object.values(groupedData)[0] || {};
    const subgroups = Object.keys(firstGroup);

    return subgroups.map((subgroup, index) => ({
      label: subgroup,
      data: Object.keys(groupedData).map(key => groupedData[key][subgroup] || 0),
    }));
  }

  purchaseDateasets(groupedData: { [key: string]: { [key: string]: number } }) {
    const customers = new Set<string>();
    Object.values(groupedData).forEach((productData) => {
      Object.keys(productData).forEach((customer) => customers.add(customer));
    });

    const customerArray = Array.from(customers);

    return Object.keys(groupedData).map((product) => {
      const data = customerArray.map((customer: string) => groupedData[product][customer] || 0);

      return {
        label: 'xxx',
        data: data,
      };
    });
  }


  updateOrdersStatisticsChart() {
    let labels: string[] = [];
    let datasets: any[] = [];

    if (this.selectedOrderStatsGroupBy === 'product') {
      const products = [...new Set(this.filteredGroupedOrder.map(item => `${item.categoryName} - ${item.typeName} - ${item.itemName}`))];
      const customers = [...new Set(this.filteredGroupedOrder.map(item => item.customerName))];

      labels = products;

      customers.forEach(customer => {
        const customerOrders = this.filteredGroupedOrder.filter(item => item.customerName === customer);
        const productData = products.map(product => {
          const [category, type, item] = product.split(' - ');
          const order = customerOrders.find(order => order.categoryName === category && order.typeName === type && order.itemName === item);
          return order ? order[this.selectedOrderStatsDataType] : 0;
        });

        datasets.push({
          label: customer,
          data: productData
        });
      });

    } else {

      const products = [...new Set(this.filteredGroupedOrder.map(item => `${item.categoryName} - ${item.typeName} - ${item.itemName}`))];
      const customers = [...new Set(this.filteredGroupedOrder.map(item => item.customerName))];

      labels = customers;

      products.forEach(product => {

        const [category, type, item] = product.split(' - ');
        const productOrders = this.filteredGroupedOrder.filter(order => order.categoryName === category && order.typeName === type && order.itemName === item);
        const customerData = customers.map(customer => {
          const order = productOrders.find(order => order.customerName === customer);
          return order ? order[this.selectedOrderStatsDataType] : 0;
        });

        datasets.push({
          label: product,
          data: customerData
        });
      });
    }


    this.orderStatsChartData = {
      labels: labels,
      datasets: datasets
    };
  }
  exportChartAsImage() {
    if (this.orderStatsPieChart && this.orderStatsPieChart.chart) {
      const chart = this.orderStatsPieChart.chart;
      const canvas = chart.canvas;
      const ctx = canvas.getContext('2d');


      ctx.save();


      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);


      const base64Image = canvas.toDataURL('image/png');


      ctx.restore();


      const link = document.createElement('a');
      link.href = base64Image;
      link.download = 'order-stats-pie-chart.png';
      link.click();
    }
  }

  exportBarChartAsImage() {
    if (this.barChart && this.barChart.chart) {
      const chart = this.barChart.chart;
      const canvas = chart.canvas;
      const ctx = canvas.getContext('2d');


      ctx.save();


      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);


      const base64Image = canvas.toDataURL('image/png');


      ctx.restore();


      const link = document.createElement('a');
      link.href = base64Image;
      link.download = 'product-inventory-chart.png';
      link.click();
    }
  }

  exportOrderStatsChartAsImage() {
    if (this.orderStatsChart && this.orderStatsChart.chart) {
      const chart = this.orderStatsChart.chart;
      const canvas = chart.canvas;
      const ctx = canvas.getContext('2d');


      ctx.save();


      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);


      const base64Image = canvas.toDataURL('image/png');


      ctx.restore();


      const link = document.createElement('a');
      link.href = base64Image;
      link.download = 'order-stats-chart.png';
      link.click();
    }
  }

  exportPieChartAsPsDF() {
    if (this.orderStatsPieChart && this.orderStatsPieChart.chart) {
      const chart = this.orderStatsPieChart.chart;
      const canvas = chart.canvas;
      const ctx = canvas.getContext('2d');

      ctx.save();

      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);


      const base64Image = canvas.toDataURL('image/png');


      ctx.restore();


      const pdf = new jsPDF('landscape');
      pdf.addImage(base64Image, 'PNG', 10, 10, 280, 150);
      pdf.save('order-stats-pie-chart.pdf');
    }
  }
  exportPieChartAsPDF() {
    if (this.orderStatsPieChart && this.orderStatsPieChart.chart) {
      const chart = this.orderStatsPieChart.chart;
      const canvas = chart.canvas;
      const ctx = canvas.getContext('2d');


      ctx.save();


      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);


      const base64Image = canvas.toDataURL('image/png');


      ctx.restore();


      const imgWidth = 280;
      const imgHeight = (canvas.height / canvas.width) * imgWidth;


      const pdf = new jsPDF('landscape');
      pdf.addImage(base64Image, 'PNG', 10, 10, imgWidth, imgHeight);
      pdf.save('order-stats-pie-chart.pdf');
    }
  }
  exportBarChartAsPDF() {
    if (this.barChart && this.barChart.chart) {
      const chart = this.barChart.chart;
      const canvas = chart.canvas;
      const ctx = canvas.getContext('2d');


      ctx.save();


      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);


      const base64Image = canvas.toDataURL('image/png');


      ctx.restore();


      const imgWidth = 280;
      const imgHeight = (canvas.height / canvas.width) * imgWidth;


      const pdf = new jsPDF('landscape');
      pdf.addImage(base64Image, 'PNG', 10, 10, imgWidth, imgHeight);
      pdf.save('product-inventory-chart.pdf');
    }
  }

  exportOrderStatsChartAsPDF() {
    if (this.orderStatsChart && this.orderStatsChart.chart) {
      const chart = this.orderStatsChart.chart;
      const canvas = chart.canvas;
      const ctx = canvas.getContext('2d');


      ctx.save();


      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);


      const base64Image = canvas.toDataURL('image/png');


      ctx.restore();


      const imgWidth = 280;
      const imgHeight = (canvas.height / canvas.width) * imgWidth;


      const pdf = new jsPDF('landscape');
      pdf.addImage(base64Image, 'PNG', 10, 10, imgWidth, imgHeight);
      pdf.save('order-stats-chart.pdf');
    }
  }


}


